// ===============================
// 🌐 BASE URLs
// ===============================
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SCHEME_BASE_URL = process.env.REACT_APP_SCHEME_BASE_URL;
export const BOOKING_BASE_URL = process.env.REACT_APP_BOOKING_BASE_URL;
export const CERTIFICATE_BASE_URL = process.env.REACT_APP_CERTIFICATE_BASE_URL;

// ===============================
// 🔐 AUTH URLs
// ===============================
export const LOGIN_URL = `${BASE_URL}/api/admin/login/admin`;

// ===============================
// 👥 USER & CATEGORY URLs
// ===============================
export const GET_USER_URL = `${BASE_URL}/api/admin/getUserLevel`;
export const GET_ADMIN_CATEGORY_TYPE_URL = `${BASE_URL}/api/admin/findUserCategoryTypeBYMainCategory`;
export const GET_ADMIN_SUB_CATEGORY_URL = `${BASE_URL}/api/admin/findUserCategorySubTypeByUserCategoryTypeId/`;
export const GET_INSITUTION_CATEGORY_URL = `${BASE_URL}/api/admin/getAllOrganizationList`;

// ===============================
// 🏢 INSTITUTION REGISTRATION
// ===============================
export const IMPORT_ADMIN_EXCEL = `${BASE_URL}/api/admin/importRegistration`;
export const GET_ORGANISATION_LIST = `${BASE_URL}/api/admin/getRegistrationOrganizationData`;
export const GET_ID_INSITUTE_VERFICATION_URL = `${BASE_URL}/api/admin/getRegistrationOrganizationDataById/`;
export const INSERT_INCORRECT_VERIFICATION_FORM_URL = `${BASE_URL}/api/admin/insertCorrection`;
export const GET_ID_INSITUTE_CLEAR_VERFIDATION_URL = `${BASE_URL}/api/admin/generateOrganizationAtom`;
export const DELETE_NON_INSITUION_VERIFIED = `${BASE_URL}/api/admin/deleteInstitutionIfNotPass`;
// ===============================
// 👤 INDIVIDUAL REGISTRATION
// ===============================
export const GET_INDIVIDUAL_LIST = `${BASE_URL}/api/admin/getRegisteredUser`;
export const GET_ID_INDIVIDUAL_VERFICATION_URL = `${BASE_URL}/api/admin/getRegisteredUserById/`;
export const GET_ID_INDIVIDUAL_CLEAR_VERFIDATION_URL = `${BASE_URL}/api/admin/generateIndivisualAtom`;
export const IMPORT_ADMIN_INDIVIDUAL_EXCEL = `${BASE_URL}/api/admin/importIndividualData`;
export const DELETE_NON_VERIFIED = `${BASE_URL}/api/admin/deleteUserIfNotPass`;
// ===============================
// ✅ VERIFICATION LIST
// ===============================
export const GET_VERIFIED_LIST = `${BASE_URL}/api/admin/getUsersVerifiedList`;
export const GET_VERIFIED_VIEW_LIST = `${BASE_URL}/api/admin/getUsersVerifiedListById/`;
export const DELETE_VERIFIED = `${BASE_URL}/api/admin/softDeleteUser`;
export const DISABLE_VERIFIED_API = `${BASE_URL}/api/admin/softDeleteInstitution`;

// ===============================
// 🛠 CORRECTION
// ===============================
export const GET_CORRECTION_LIST = `${BASE_URL}/api/admin/getCorrection`;



// ===============================
// 📣 ADMIN COMMUNICATION
// ===============================
export const GET_NOTIFICATION_FOR_VALUES = `${BASE_URL}/api/getAllNotificationForData`;
export const GET_CATEGORIES = `${BASE_URL}/api/admin/getUserCategiryMain`;
export const GET_CATEGORIES_TYPE = `${BASE_URL}/api/admin/findUserCategoryType`;
export const GET_CATEGORY_SUB_TYPE = `${BASE_URL}/api/admin/findUserCategorySubTypeByUserCategoryTypeId`;
export const POST_DATA = `${BASE_URL}/api/addNotificationAndSendNotification`;
export const GET_COMMUNICATION_DATA = `${BASE_URL}/api/getAllNotificationData`;
export const GET_NEW_NOTIFICATION_DETAILS_BY_ID = `${BASE_URL}/api/getViewUsersNotificationDetailsBYID`;
export const GET_ALL_WEBSITE_NOTIFICATION = `${BASE_URL}/api/getAllWebsiteNotification`;
export const VIEW_WEBSITE_NOTIFICATION = `${BASE_URL}/api/getViewWebsiteNotificationDetailsBYID`;
export const UPDATE_USER_NOTIFICATION_STATUS = `${BASE_URL}/api/getUpdateUsersNotificationStatus`;
export const UPDATE_WEBSITE_NOTIFICATION_STATUS = `${BASE_URL}/api/getUpdateWebsiteNotificationStatus`;

// ===============================
// 🗓 EVENT APIs
// ===============================
export const POST_EVENT = `${BASE_URL}/api/addEventCalenderData`;
export const EDIT_EVENT = `${BASE_URL}/api/updateEventCalenderData`;
export const UPDATE_EVENT_STATUS = `${BASE_URL}/api/getUpdateEventCalenderStatus`;
export const GET_ALL_EVENT_CALENDAR_DATA = `${BASE_URL}/api/getEventCalenderAllData`;
export const PREVIEW_EVENT_CALENDAR_DATA = `${BASE_URL}/api/getViewEvenCalendertDetailsBYID`;
export const GET_EVENT_TYPE_LIST = `${BASE_URL}/api/eventList`;

// ===============================
// 🎟️ GRIEVANCE TICKET APIs
// ===============================
export const getAllUserGrievanceTicketEndPoint = `${BASE_URL}/api/user/getAllTicketData`;
export const getAllUserNotificationEndPoint = `${BASE_URL}/api/getAllNotificationData`;
export const getSingleUserGrievanceTicketEndPoint = `${BASE_URL}/api/user/getTicketHistory`;
export const addUserGrievanceTicketReplyEndPoint = `${BASE_URL}/api/user/addTicketReply`;
export const addGrievanceTicketEndPoint = `${BASE_URL}/api/user/addTicketData`;
export const getAllGrievanceTicketEndPoint = `${BASE_URL}/api/admin/getAllTicketData`;
export const getAllGrievancePublicEndPoint = `${BASE_URL}/api/admin/grievance/list`;
export const getSingleGrievanceTicketEndPoint = `${BASE_URL}/api/admin/getTicketHistory`;
export const addGrievanceTicketReplyEndPoint = `${BASE_URL}/api/admin/addTicketReply`;
export const updateStatusPriorityGrievanceTicketEndPoint = `${BASE_URL}/api/admin/updateTicketStatus`;
export const updateStatusPrioritypublicGrievanceTicketEndPoint = `${BASE_URL}/api/admin/grievance/updateStatusAndPriority`;

export const GET_ALL_DISCOUNT_APPLICATIONS = `${BOOKING_BASE_URL}/api/auth/discount/users/applications`;

// ===============================
// 🧑‍💼 ADMIN CREATION
// ===============================
export const CREATE_ADMIN_URL = `${BASE_URL}/api/admin/createDSO`;
export const UPDATE_ADMIN_URL = `${BASE_URL}/api/admin/updateDSO`;
export const GET_DSO_URL = `${BASE_URL}/api/admin/getAllDSO`;

// ===============================
// 🏟️ BOOKING
// ===============================
export const BOOKING_URL = `${BOOKING_BASE_URL}/api/auth/v3/checkAndGet/booking`;
export const BOOKING_DETAILS = `${BOOKING_BASE_URL}/api/auth/booking`;
export const BOOKING_LIST = `${BOOKING_BASE_URL}/api/auth/admin/homescreen/booking`;
export const BOOKING_STATUS = `${BOOKING_BASE_URL}/api/auth/v3/checkAndGet/booking`;

// ===============================
// ❌ USER DELETE
// ===============================
export const USER_DELETE_URL = `${BASE_URL}/api/user/delete-account`;

export const GET_DSO_ADMIN_CATEGORY_URL = "/api/admin/adminCategoryType";



//EDIT PROFILE LIST
export const EDIT_USER_PROFILE_LIST = "/api/admin/updateDetailsList"
export const APPROVE_EDIT_USER_PROFILE = "api/admin/updateDetails"
export const UPDATE_EDIT_USER_DETAILS_BY_ID = "/api/admin/updateDetailsById/"


//EditUserProfile
export const GET_EDIT_USER_PROFILE = "api/user/updateProfileList"
export const GET_UPDATE_USER_PROFILE = "api/user/getSingleUpdateProfileData"
export const DELETE_UPLOAD_DOCUMENT = "api/user/deleteUploadDocument"


// Account Management

export const CREATE_ACCOUNT_USER_URL = "/api/admin/usp-users/create";
export const UPDATE_ACCOUNT_USER_URL = "/api/admin/usp-users/update";
export const DELETE_ACCOUNT_USER_URL = "/api/admin/usp-users/delete";
export const DEACTIVATE_ACCOUNT_USER_URL = "/api/admin/usp-users/activate-deactivate";
export const ACCOUNT_USER_PROFILE_URL = "/api/admin/usp-users/profile";
export const ACCOUNT_USER_PASSWORDRESET_URL = "/api/admin/usp-users/reset-password";
export const GET_ACCOUNT_USER_LIST_URL = "api/admin/usp-users/list";
export const GET_ACCOUNT_USER_statistics_URL = "api/admin/dashboard/statistics";
export const GET_ACCOUNT_USER_ASSIGN_ROLE_URL = "/api/admin/usp-roles/list";
export const GET_ACCOUNT_USER_PERMISSION_ROLE_URL = "/api/admin/usp-roles/permissions";
export const GET_ACCOUNT_USER_UPDATE_PERMISSION_ROLE_URL = "/api/admin/usp-roles/update";
export const CREATE_ACCOUNT_USER_PERMISSION_ROLE_URL = "/api/admin/usp-roles/create";
// Account Management Role
export const GET_ACCOUNT_ASSIGN_ROLE__LIST_URL = "/api/admin/usp-roles/list";
export const ADD_ACCOUNT_ASSIGN_ROLE = "/api/admin/usp-roles";
export const GET_ACCOUNT_ASSIGN_USER = "/api/admin/usp-roles";
export const GET_ASSIGN_USER_BY_ID = "/api/admin/usp-roles";
export const GET_ROLE_DELETE = "/api/admin/usp-roles/delete";
export const GET_ASSIGN_ROLE_DELETE = "/api/admin/usp-roles";


// USP Menu Items
export const GET_USP_MENU_LIST = "/api/admin/usp-menu/admin/list-all";
export const GET_USP_MENU_ADMIN_LIST = "/api/admin/usp-menu/admin/list";
export const GET_USP_MENU_BY_ID = "/api/admin/usp-menu/show";
export const CREATE_USP_MENU = "/api/admin/usp-menu/create";
export const UPDATE_USP_MENU = "/api/admin/usp-menu/update";
export const DELETE_USP_MENU = "/api/admin/usp-menu/delete";
export const FETCH_DASHBOARD_DATA = "/api/admin/dashboard/registgitration"
export const FETCH_Booking_DATA = "/api/admin/dashboard/venue"

export const FETCH_HostelAndCourse_DATA = "/api/admin/dashboard/hostelAndCourse"

export const FETCH_Visitor_DATA = "/api/admin/dashboard/visitors"

// ===============================
// 🎓 CERTIFICATES & ACCREDITATIONS (ADDED HERE)
// ===============================
export const User_Certificate_Certificate = `${CERTIFICATE_BASE_URL}/api/user-certificate/certificate`;
export const User_Certificate_Accred = `${CERTIFICATE_BASE_URL}/api/user-certificate/accred`;

export const DOWNLOAD_EXCEL = "/api/admin/new-download-verification-entities/"









export const REACT_Certificate_URL = process.env.REACT_APP_DIGICERT_Certificate_URL;
export const REACT_ACCREDITATION_URL = process.env.REACT_APP_ACCREDITATION_URL || "https://staging-accreditation.jharkhandsports.in";


export const getAllUserGrievanceNotificationEndPoint = "api/getAllNotificationData";
export const TICKET_QR_SCAN = `/api/v1/ticket/verify`
export const EVENT_BOOKING_LIST = `/api/v1/manager/bookings`
export const MY_EVENTS = `/api/v1/manager/events`
export const TICKET_GRANT_ACCESS = (id) => `/api/v1/bookings/verify?id=${id}`
export const CHECK_TICKET_ID = `/api/v1/manager/booking`
export const TICKET_DETAILS = `/api/v1/bookings`
export const GET_ALL_CLUSTERS = `/api/auth/getAllClusters`;
export const GET_ALL_VENUES = `/api/auth/getAllVenueByClusterId`;
export const GET_ALL_FACILITIES = `/api/auth/getAllFacilityByVenueId`;
export const GET_ALL_FACILITIES_NEW = `/api/auth/getAllFacilityByVenueIdNew`;
export const GET_ALL_EXISITING_USERS = `/api/auth/get_individuals_list`;
export const GET_ALL_STATES = `/api/auth/ext/states`;
export const GET_ALL_DISTRICTS_BY_STATE = `/api/auth/ext/district`
export const GET_TIME_SLOTS = `/api/auth/venue/getslotsNew`;
export const BOOKING_USER = "/api/auth/booking/venue_manager";
export const UPDATE_PAYMENT_STATUS = "/api/auth/payment/updatePaymentStatus"
export const GET_BOOKING_DETAILS = `/api/auth/booking`
export const CHECK_DUPLICATE_VALUES = `/api/auth/mobile_existence`



// Notification
// export const GET_NOTIFICATION_URL = "/api/notifications/check"
export const GET_NOTIFICATION_URL = ""
export const UPDATE_NOTIFICATION_URL = "/api/notifications/seen"



export const GET_MEDICAL_HISTORY="/api/user/medical_history"
export const ADD_MEDICAL_HISTORY="/api/user/medical_history"
export const UPDATE_MEDICAL_HISTORY = "/api/user/medical_history"
export const ADD_INJURY_HISTORY="/api/user/medical_history"



// Account Management



export const ADMIN_ME = "/api/admin/me";
export const ADMIN_ME_COACH = "/api/admin/me-coach";
export const BATCH_LIST = "/api/admin/ams-batches";


// export const GET_DSO_ADMIN_CATEGORY_URL = "/api/admin/adminCategoryType"


export const USER_MENU = "/api/admin/findUserCategoryType";

export const UPDATE_BATCH = "/api/admin/ams-batches";

export const BATCH_ATHLETES = "/api/admin/athletes";

export const AMS_VENUE = "/api/admin/ams-venues";

export const AMS_SUPERVISOR = "/api/admin/ams-supervisors";

export const TRAINING_LIST = "/api/admin/trainings";

export const POST_TRAINING = "/api/admin/trainings-store";

export const GET_EQUIPMENT = "/api/admin/equipments";

export const CATEGORY_LIST = "/api/admin/ams-categories";


export const AMS_DASHBOARD_STATS = "/api/admin/ams-dashboard-stats";
export const AMS_COACH_ATHLETE_STATS = "/api/admin/ams-coach-athlete-stats";
export const AMS_COACH_ATHLETES = "/api/admin/ams-coach-athletes";
export const AMS_COACH_ATHLETES_EXPORT = "/api/admin/ams-coach-athletes-export";
export const AMS_ATTENDANCE_REPORT = "/api/admin/trainings/attendance-report";
export const AMS_MY_SESSIONS = "/api/admin/trainings/my-sessions";
export const AMS_ATTENDANCE_STATS = "/api/admin/trainings/attendance-stats";
export const AMS_ATTENDANCE_EXPORT = "/api/admin/trainings/attendance-export";
export const AMS_TRAINING_LIST_SUMMARY = "/api/admin/trainings/list-summary";

// Government Orders
export const GOVT_ORDER_ADMIN_URL = "/api/admin/government-orders";
export const GOVT_ORDER_PUBLIC_URL = "/api/government-orders";

// Circulars
export const CIRCULAR_ADMIN_URL = "/api/admin/circulars";

// Uddyamaan Unnayan Yojana
export const UDDYAMAAN_APPLICATION_ADMIN_URL = "/api/admin/uddyamaan/applications";

// Geographic data
export const GEO_BLOCKS_URL = "/api/admin/geo/blocks";
export const GEO_NYAY_PANCHAYATS_URL = "/api/admin/geo/nyay-panchayats";

// COE REGISTRATION APIs
export const COE_ADMIN_REGISTRATIONS = "/api/admin/coe/registrations";
export const COE_SPORTS_DISCIPLINES = "/api/coe/sports-disciplines";
export const COE_TRAINING_CENTRES = "/api/coe/training-centres";
export const COE_DISTRICTS_BY_STATE = (stateId = 4025) => `/api/district/${stateId}`;



